const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6799"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157548",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.941-839.737h9.486v-3.474a4.649 4.649 0 0 0-1.383-3.383 4.538 4.538 0 0 0-3.36-1.405 4.538 4.538 0 0 0-3.36 1.405 4.648 4.648 0 0 0-1.383 3.383zM180-838v-1.737h2.2v-3.474a6.277 6.277 0 0 1 1.07-3.559 5.574 5.574 0 0 1 2.84-2.23 5.644 5.644 0 0 1-2.836-2.236 6.251 6.251 0 0 1-1.07-3.554v-3.474H180V-860h17.368v1.737h-2.2v3.474a6.251 6.251 0 0 1-1.07 3.554 5.644 5.644 0 0 1-2.84 2.235 5.574 5.574 0 0 1 2.836 2.23 6.277 6.277 0 0 1 1.07 3.559v3.474h2.2V-838z",
    transform: "translate(-173 865)",
    style: {
      fill: "#527ff2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingIcon);
export default __webpack_public_path__ + "static/media/waiting_icon.1fd944e442870351f2c0b86054201f70.svg";
export { ForwardRef as ReactComponent };